/**
 * Ruta `/codigo` (US2, T033): "Tengo un código" dentro de la PWA instalada.
 *
 * Canjea el código de traspaso por un token de invitación nuevo (la API rota el token, wiring §4.2),
 * lo guarda en `sessionStorage` y sigue al registro del dispositivo.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { setActivationToken } from '../features/activation/activation-store';
import { HandoffCodeScreen } from '../features/activation/handoff-code';

/**
 * Tras canjear el código: guarda el token rotado y sigue al registro. Lo comparten `/codigo` y
 * `/dispositivo-no-registrado` (que ahora pide el código en su propia pantalla).
 */
export function useContinueAfterRedeem(): (token: string) => void {
  const navigate = useNavigate();
  return (token) => {
    setActivationToken(token);
    void navigate({ to: '/registrar', replace: true });
  };
}

export function HandoffCodeRoute() {
  const navigate = useNavigate();
  const onRedeemed = useContinueAfterRedeem();

  return (
    <HandoffCodeScreen
      onRedeemed={onRedeemed}
      onNoCode={() => void navigate({ to: '/dispositivo-no-registrado' })}
    />
  );
}

export const Route = createFileRoute('/codigo')({
  component: HandoffCodeRoute,
});
